import {
    ASSET_INFO_LIST_TAB,
    navigateWithChildTab,
    pickDetailTabTitle,
} from "../pageTabs/pageTabsStorage";
import {KV_LIST_TYPES} from "./detailKvListLabels";

export const ASSET_CONTRACT_LIST_TAB = {
    url: "/asset/contract",
    title: "자산계약관리",
};

/** listType별 하위 탭 바로가기 가능 여부 */
export function hasKvListNavigation(listType) {
    return listType === KV_LIST_TYPES.asset || listType === KV_LIST_TYPES.contract;
}

/** KV 다건 목록 — 항목별 상세 바로가기 */
export function navigateKvListItem(navigate, item, listType) {
    if (!navigate || item?.id == null) return;

    if (listType === KV_LIST_TYPES.asset) {
        navigateWithChildTab(navigate, {
            title: pickDetailTabTitle(item, "자산상세"),
            url: `/asset/${item.id}`,
            headerUrl: ASSET_INFO_LIST_TAB.url,
            headerTitle: ASSET_INFO_LIST_TAB.title,
        });
        return;
    }

    if (listType === KV_LIST_TYPES.contract) {
        navigateWithChildTab(navigate, {
            title: pickDetailTabTitle(item, "계약 상세"),
            url: `/asset/contract/${item.id}`,
            headerUrl: ASSET_CONTRACT_LIST_TAB.url,
            headerTitle: ASSET_CONTRACT_LIST_TAB.title,
        });
        return;
    }
}
